import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios'
import { auth } from '../../../../../services';
import { ROOT_API_URL } from "../../../../../api-config";
import { getRegions, getDistricts } from '../../../../../Redux/Actions/CommonActions';
import { Link } from 'react-router-dom';
import GoogleMapReact from 'google-map-react';
import Geocode from "react-geocode";

const AnyReactComponent = ({ text }) => <div>{text}</div>;

class EventDetails extends Component {
    static defaultProps = {
        center: {
            lat: 32.7505974,
            lng: -97.3403577
        },
        zoom: 14
    }
    constructor(props) {
        super(props);

        this.state = {
            lat: 0,
            lng: 0,
            event: {
                address1: "",
                address2: "",
                city: "",
                description: "",
                district: null,
                districtId: null,
                endDate: "",
                eventCategory: null,
                eventCategoryID: 1,
                eventCategoryName: "",
                eventID: 1,
                eventRSVPId: 0,
                externalURL: "",
                externalURLLabel: "",
                image: null,
                imageFile: null,
                imageURL: "",
                isActive: true,
                location: "",
                region: null,
                regionId: 1,
                rsvpCount: 0,
                rsvpResponse: false,
                startDate: "",
                state: null,
                stateId: 44,
                stateName: "",
                title: "",
                zip: ""
            }
        }
    }

    componentDidMount() {
        const eventId = this.props.location.pathname.replace("/eventdetails/", "");
        var userId = auth.getAuthUserId();
        axios.get(`${ROOT_API_URL}/events/GetEventById?eventId=${eventId}&userId=${userId}`)
        .then(res => {
            Geocode.setApiKey("AIzaSyBCpGvyQOGZNBK4yWDO7jp5GjyJmD6ZKjU");
            Geocode.fromAddress(`${res.data.address1} + " " + ${res.data.address2} + " " + ${res.data.city} + " " + ${res.data.stateName} + " " + ${res.data.zip}`).then(
                response => {
                    const { lat, lng } = response.results[0].geometry.location;
                    console.log(lat, lng);
                    this.setState({
                        lat: lat,
                        lng: lng,
                        event: res.data
                    })
                },
                error => {
                    console.error(error);
                }
            );
        });
    }

    formatDate = (date) => {
        let month = date.getMonth() + 1;
        month = month.toString().length != 2 ? '0' + month.toString() : month;
        let day = date.getDate();
        day = day.toString().length != 2 ? '0' + day.toString() : day;
        let year = 1900 + date.getYear();
        let minutes = date.getMinutes();
        minutes = minutes.toString().length != 2 ? '0' + minutes.toString() : minutes;
        let hour = "";
        let suffix = "AM"
        if (date.getHours() >= 12) {
            hour = date.getHours() - 12;
            suffix = "PM";
            if (hour.toString().length != 2) {
                hour = '0' + hour;
            }
        }
        else if (date.getHours() == 0) {
            hour = 12;
        }
        else {
            hour = date.getHours();
            if (hour.toString().length != 2) {
                hour = '0' + hour;
            }
        }

        return month + "/" + day + "/" + year + " " + hour + ":" + minutes + " " + suffix;
    }

    render() {        
        return (
            <div className="eventDetails">
                <Link to='/events' className="backToEventsBtn" >
                    <img src="/images/back-to-events-arrow.png" alt="back to events" />Back to Events
                </Link>
                <div className="eventDetailsContainer">
                    <h1 className="eventTitle">{this.state.event.title}</h1>
                    <div className="row cols">
                        <div className="col-lg-6 col-left">
                            <div className="col-lg-3 col-left">
                                <p className="eventInfoHeader">Event Info</p>
                                <p className="eventDescription">{this.state.event.description}</p>
                            </div>
                            <div className="col-lg-3 col-right">
                               <img alt="" src={this.state.event.imageURL} /> 
                            </div>
                            <ul className="eventListStyles">
                                <li className="eventItemInfo date cols">
                                    <span className="eventItemLeft col-left">Date(s): </span>
                                <span className="col-right">
                                    {this.state.event.startDate? 
                                        'Start Date: '+ this.formatDate(new Date(this.state.event.startDate)): ""} 
                                        {this.state.event.startDate? '-' : ""}<br/>
                                        {this.state.event.startDate? 'End Date: '+ this.formatDate(new Date(this.state.event.endDate)): "" }
                                        <br/>(Local Time)</span>
                                </li>
                                <li className="eventItemInfo location cols">
                                    <span className="eventItemLeft leftDate col-left">Location: </span>
                                    <span className="col-right">{this.state.event.location} <br /> {this.state.event.address1} <br /> {this.state.event.address2} {this.state.event.city}, {this.state.event.state} {this.state.event.zip}</span>
                                </li>
                                <li className="eventItemInfo link cols">
                                    <span className="eventItemLeft col-left">Event Link: </span>
                                    <span className="col-right"><a href={this.state.event.externalURL} target="_blank">{this.state.event.externalURLLabel}</a></span>
                                </li>
                            </ul>
                        </div>
                        <div className="col-lg-6 col-right">
                            <div className="event-map">
                                {this.state.lat !== 0 && this.state.lng !== 0 ?
                                    <GoogleMapReact
                                        bootstrapURLKeys={{ key: 'AIzaSyBXF4z_9gUBiU4TGpbyX3UrC3Wv2TjrMZg' }}
                                        defaultCenter={{
                                            lat: this.state.lat,
                                            lng: this.state.lng
                                        }}
                                        defaultZoom={14}
                                    >
                                        <AnyReactComponent
                                            lat={this.state.lat}
                                            lng={this.state.lng}
                                            text={<div className="event-map-text"><img className="event-map-image" src="/images/map-icon.png" alt="map icon" />{this.state.event.title}</div>}
                                        />
                                    </GoogleMapReact>
                                : ""}                            
                            </div>
                         </div>
                    </div>
                </div>
            </div>
        );
    }
}


function mapStateToProps(state) {
    return {
        authentication: state.authentication,
        common: state.common
    }
}

export default connect(mapStateToProps, { getRegions, getDistricts })(EventDetails);